module.exports = __webpack_public_path__ + "static/img/07.862d1193.jpg";